import { defineComponent as _defineComponent } from 'vue'
import PopupBase from '@/vue/common/popupBase.vue'
  import EcoActions from '@/vue/responsible-stay/components/EcoActions.vue'
  import RSEblock from '@/vue/responsible-stay/components/RSEblock.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EcoPopup',
  props: {
    isOpen: Boolean,
    title: String,
    isCriteriaFloconVert: Boolean,
    isCriteriaCleVerte: Boolean,
  },
  emits: ['close'],
  setup(__props, { emit }) {

  

  

  const close = () => {
    emit('close')
  }

return { __sfc: true,emit, close, PopupBase, EcoActions, RSEblock }
}

})